import { render, staticRenderFns } from "./loanagreement.vue?vue&type=template&id=710be9df&"
import script from "./loanagreement.vue?vue&type=script&lang=js&"
export * from "./loanagreement.vue?vue&type=script&lang=js&"
import style0 from "./loanagreement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports